export interface DocumentTemplatePlaceholderRelatedField {
  name: string;
  label: string;
}

export interface DocumentTemplatePlaceholderFieldType {
  name: string;
  id: string;
  subFields: DocumentTemplatePlaceholderRelatedField[];
}

type DocumentTemplatePlaceholderFieldTypes = {
  [key: string]: DocumentTemplatePlaceholderFieldType;
};

export const DOCUMENT_TEMPLATE_PLACEHOLDER_FIELD_TYPES = {
  LegalEntity: {
    name: "Legal entity",
    id: "3faa8dfd-8581-4835-9382-df295459697f",
    subFields: [
      {
        name: "registeredAddress",
        label: "Registered address",
      },
      {
        name: "registeredName",
        label: "Registered name",
      },
    ],
  },
  Employee: {
    name: "Employee",
    id: "389201b1-738c-4549-b5a4-4ea69d3f0274",
    subFields: [
      {
        name: "email",
        label: "Email",
      },
      {
        name: "taxId",
        label: "Tax ID",
      },
      {
        name: "birthDate",
        label: "Birth date",
      },
      {
        name: "department",
        label: "Department",
      },
      {
        name: "address",
        label: "Address",
      },
    ],
  },
  Amount: {
    name: "Amount",
    id: "ec983c50-a5c6-415e-ac5e-39398f1db097",
    subFields: [],
  },
  Date: {
    name: "Date",
    id: "14137d23-f279-4fc5-98ae-e1d6c0a07c49",
    subFields: [],
  },
  FreeText: {
    name: "Free text",
    id: "2a087519-9472-41d9-b076-0d948c2fb7a0",
    subFields: [],
  },
};

export const getFieldType = (fieldTypeId: string): DocumentTemplatePlaceholderFieldType | null => {
  return (
    (Object.values(DOCUMENT_TEMPLATE_PLACEHOLDER_FIELD_TYPES).find(
      (fieldType) => fieldType.id === fieldTypeId
    ) as DocumentTemplatePlaceholderFieldType) ?? null
  );
};

export const isLinkablePlaceholder = (placeholderFieldTypeId: string) => {
  const fieldType = getFieldType(placeholderFieldTypeId);

  return fieldType?.subFields && fieldType?.subFields.length > 0;
};

export const getSubField = (placeholderFieldTypeId: string, subfield: string) => {
  const fieldType: DocumentTemplatePlaceholderFieldType | null = getFieldType(placeholderFieldTypeId);
  return fieldType?.subFields.find((_subfield) => _subfield.name === subfield) ?? null;
};
